import React from 'react';
import { tv } from 'tailwind-variants';
import Slot from '@/components/ui/Slot';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  ariaLabel?: string;
  children: React.ReactNode;
  disabled?: boolean;
  dropdownContent?: React.ReactNode;
  loading?: boolean;
  playing?: boolean;
}

interface SlotProps {
  children: ReactChildren;
  className?: string;
}

export const containerVariants = tv({
  base: [
    'tw-flex',
    'hover:tw-shadow-[0_3px_5px_rgba(0,0,0,0.1)]',
    'tw-mr-1',
  ],
  variants: {
    dropdownButtonLocation: {
      inside: '!tw-rounded',
      outside: 'tw-border tw-border-solid tw-border-grey tw-rounded tw-h-10 tw-box-border',
    },
  },
});

export const buttonVariants = tv({
  base: [
    'tw-flex tw-justify-center tw-items-center',
    'tw-py-1.5',
    'tw-no-underline tw-box-border tw-text-tci-purple',
  ],
  variants: {
    disabled: {
      false: 'tw-cursor-pointer',
      true: 'tw-cursor-not-allowed tw-text-grey',
    },
    dropdownButtonLocation: {
      inside: 'tw-border tw-border-solid tw-border-grey tw-rounded tw-px-2.5 tw-h-10',
      outside: 'tw-border-0 tw-rounded-l tw-pl-2.5 tw-pr-1',
    },
  },
});

export const DropdownContentComponent = ({ children, ...props }: SlotProps) => (
  <Slot {...props}>{children}</Slot>
);

export const ButtonContentComponent = ({ children, ...props }: SlotProps) => (
  <Slot {...props}>{children}</Slot>
);

